/* template */
<template><page><base-container><cube-input :value="value" mpxModelEvent="input" :type="(type)" :placeholder="(placeholder)" :maxlength="(maxlength)" :disabled="(disabled)" :clearable="(clearable)" :eye="(eye)" @mpxModel='(e)=>__invoke(e, [["__model","value", "__mpx_event__", ["value"], undefined]])'/><div :class='["title","last"]'>value: {{ value }}</div><div><div :class='["title"]'>Options</div><div :class='["option-list"]'><div :class='["group"]'><div :class='["group-item","last"]'><div :class='["item"]'>disabled</div><mpx-switch :color="(switchColor)" :checked="(disabled)" @change='(e)=>__invoke(e, [["updateDisabled"]])'/></div></div><div :class='["group"]'><div :class='["group-item","last"]'><div :class='["item"]'>maxlength:10</div><mpx-switch :color="(switchColor)" :checked="(maxlength10)" @change='(e)=>__invoke(e, [["updateMaxLength"]])'/></div></div><div :class='["group"]'><div :class='["group-item"]'><div :class='["item"]'>clearabled</div><mpx-switch :color="(switchColor)" :checked="(useClear)" @change='(e)=>__invoke(e, [["updateUseClear"]])'/></div><div :class='["group-item","last"]' v-if="(useClear)"><div :class='["item"]'>blur hiden</div><mpx-switch :color="(switchColor)" :checked="(clearBlurHidden)" @change='(e)=>__invoke(e, [["updateClearBlur"]])'/></div></div><div :class='["group"]'><div :class='["group-item"]'><div :class='["item"]'>password</div><mpx-switch :color="(switchColor)" :checked="(isPwd)" @change='(e)=>__invoke(e, [["updatePwd"]])'/></div><div :class='["group-item"]'><div :class='["item"]'>show eye</div><mpx-switch :color="(switchColor)" :checked="(showEye)" @change='(e)=>__invoke(e, [["updateShowEye"]])'/></div><div :class='["group-item"]'><div :class='["item"]'>reverse</div><mpx-switch :color="(switchColor)" :checked="(reverse)" @change='(e)=>__invoke(e, [["updateReverse"]])'/></div><div :class='["group-item","last"]'><div :class='["item"]'>password visible</div><mpx-switch :color="(switchColor)" :checked="(pwdVisible)" @change='(e)=>__invoke(e, [["updatePwdVisible"]])'/></div></div></div></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_eb6c8c90"}'>
  .title
    padding: 15px
    margin-bottom: 15px
    font-size: 16px
    font-weight: 500
    border-bottom: 1px solid rgba(0, 0, 0, .1)
    color: #333
  .options
    margin-bottom: 15px
  .group
    margin-bottom: 15px
    border: 1px solid rgba(0, 0, 0, .1)
    border-radius: 5px
  .group-item
    display: flex
    align-items: center
    justify-content: space-between
    padding-right: 10px
    border-bottom: 1px solid rgba(0, 0, 0, .1)
  .item
    padding-left: 15px
    line-height: 52px
    text-align: left
    white-space: nowrap
  .last
    border-bottom: none  
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_eb6c8c90"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_eb6c8c90"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_eb6c8c90"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-input':getComponent(require("../../../packages/mpx-cube-ui/src/components/input/index.mpx?isComponent&outputPath=components%2Findex0d21bf37%2Findex")),'mpx-switch':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-switch?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>